import { LogoColor } from "@boundary/components/phodoLogos";
import styles from "./splashScreen.module.scss";

export function SplashScreen() {
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.gradient} />
        <div className={styles.content}>
          <LogoColor className={styles.logo} />
          <p className={styles.text}>
            Экономим время людей, печатая без очередей!
          </p>
        </div>
      </div>
    </div>
  );
}

